export default "__VITE_ASSET__CNXstd3B__"